<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container">
                <div class="modal-header">
                    <div class="modal-title">
                        {{ modalTitle }}
                    </div>
                    <div class="modal-header__close-button" @click="onCloseModal">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18 6L6 18M6 6L18 18" stroke="#A8A8A8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                </div>
                <div
                    class="modal-body">
                    <div class="modal-body-element"
                         v-for="group in groups">
                        <span>{{ group }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'LettersMailingsGroupsModal',
    props: {
        modalTitle: {
            type: String,
            default: 'Title',
            Required: true
        },
        groups: {
            type: Array,
            Required: true
        }
    },
    methods: {
        onCloseModal: function() {
            this.$emit('closeModal');
        },
    },
}
</script>

<style scoped>
.modal-title {
    font-size: 18px;
}
.modal-body {
    max-height: 350px;
    overflow-y: auto;
}
.modal-body-element {
    padding: 6px 0px;
    display: flex;
    gap: 6px;
    font-size: 18px;
    color: #575F6E;
}
</style>
